import { PrinterType } from '../../../../Model/Printer';
import DetectSunmiDevice from '../../../../app/Merchant/service/PrintService/DetectSunmiDevice';
import MerchantAppData from './../../../../Model/MerchantAppData';

let _lastRawReceipt = null
const defaultSunmiPrinter = {
    printer_type: PrinterType.SUNMI,
    paperSize: 58
}
export default class MerchantPrinter {
    static printBillBySession(sessionID, data, success) {
        if (window.isAndroidHandHeldTerminal) {
            if (window.MerchantHandHeldTerminal) {
                if (window.MerchantHandHeldTerminal.print) {
                    window.MerchantHandHeldTerminal.print("table_session_receipt", sessionID)
                }
            }
            return
        }
        else if (window.isFlutterAppReady && window.flutter_inappwebview) {
            // Directly send to custom printer to print
            if (MerchantAppData.data.state.customReceiptPrinter) {
                MerchantPrinter.loadPrintDataThenFlutterPrint(sessionID)
                return
            }
        }

        // Default pass print request to server and server to handle
        // the routing logic
        $.ajax({
            url: "/merchant/api/order/" + sessionID + "/printbill",
            type: "POST",
            data: JSON.parse(JSON.stringify(data)),
            success: success
        })
    }


    static printClosedBillBySession(sessionID, success) {
        const customReceiptPrinter = MerchantAppData.data.state.customReceiptPrinter

        let timer = null
        const printAfterAppIsReady = (sessionID, printer, success) => {
            if (!window.isFlutterAppReady) {
                if (timer) {
                    clearTimeout(timer)
                }
                timer = setTimeout(() => {
                    printAfterAppIsReady(sessionID, printer, success)
                }, 500);
            }
            else {
                if (timer) {
                    clearTimeout(timer)
                }
                MerchantPrinter.loadPrintDataThenFlutterPrint(sessionID, printer)
                .then(() => {
                    success && success()
                })
            }
        }

        if (window.isAndroidHandHeldTerminal) {
            if (window.MerchantHandHeldTerminal) {
                if (window.MerchantHandHeldTerminal.print) {
                    window.MerchantHandHeldTerminal.print("table_session_receipt", sessionID)
                }
            }
            return
        }
        else if (window.flutter_inappwebview && customReceiptPrinter && customReceiptPrinter.is_device_custom_printer) {
            console.log("Use device custom printer to print")
            printAfterAppIsReady(sessionID, null, success)
            return
        }
        else if (window.flutter_inappwebview && DetectSunmiDevice.sunmiDevice.isSunmiDevice && MerchantAppData.data.getMerchantSettingValue('use_sunmi_printer_to_print')) {
            console.log("Use sunmi printer to print")
            printAfterAppIsReady(sessionID, defaultSunmiPrinter, success)
            return
        }

        let data = {
            printer_id: null,
        }
        if (MerchantAppData.data.state.customReceiptPrinter) {
            data.printer_id = MerchantAppData.data.state.customReceiptPrinter.id
        }
        $.ajax({
            url: "/merchant/api/order/" + sessionID + "/printClosedbill",
            type: "POST",
            data: data,
            success: success
        });
    }

    static loadPrintDataThenFlutterPrint = (sessionID, printer) => {
        let paperSize = 80
        if (MerchantAppData.data.state.customReceiptPrinter && MerchantAppData.data.state.customReceiptPrinter.is_bluetooth) {
            // Bluetooth printer is 58mm paper
            paperSize = 58
        }
        else if (printer && printer.paperSize) {
            paperSize = printer.paperSize
        }

        return new Promise((resolve, reject) => {
            $.ajax({
                url     : `/merchant/api/table_sessions/${sessionID}/raw_receipt`,
                data    : {
                    paper_size: paperSize,
                    printer_type: printer && printer.printer_type,
                },
                success : (rawReceipt) => {
                    _lastRawReceipt = rawReceipt
                    MerchantPrinter.flutterPrintRawContent(rawReceipt, printer)
                        .then(resolve)
                }
            })
        })
    }

    static flutterTestPrint(printer) {
        if (window.flutter_inappwebview && window.isFlutterAppReady) {
            return window.flutter_inappwebview.callHandler('flutterTestPrint', printer || MerchantAppData.data.state.customReceiptPrinter)
        }
        else {
            return Promise.resolve()
        }
    }
    static flutterPrintRawContent(rawContent, printer = null) {
        if (window.flutter_inappwebview && window.isFlutterAppReady) {
            return window.flutter_inappwebview.callHandler('flutterPrint', rawContent, printer || MerchantAppData.data.state.customReceiptPrinter)
        }
        else {
            return Promise.resolve({})
        }
    }
    static lastReceipt() {
        return _lastRawReceipt
    }
}